import React from 'react';
import { PublishingPost } from '~/post/types.generated';
import { PostCampaignSelector } from '~/shared-components/PostCampaignSelector';

type PropType = {
  post: PublishingPost;
};

export const CampaignActions = ({ post }: PropType): JSX.Element => (
  <PostCampaignSelector size="small" postId={post.id} />
);
